<template>
  <div class="side-menu no-bar">
    <ul>
      <li
        v-for="(item, index) in menuList"
        :key="index"
        :class="{ active: activeMenu == item.value }"
        @click="selectMenu(item.value)"
      >
        <span class="icon">
          <svg-icon :icon-class="'rule_' + item.icon" style="font-size: 14px"></svg-icon>
        </span>
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import { labelMap } from "./static"
export default {
  name: "side-menu",
  props: {
    activeMenu: {
      type: String,
      default: "hide"
    }
  },
  data() {
    return {
      menuList: labelMap
    }
  },
  methods: {
    selectMenu(value) {
      if (this.activeMenu == value) return
      this.$emit("update:activeMenu", value)
    }
  }
}
</script>

<style lang="scss" scoped>
.side-menu {
  border-right: 1px solid #ddd;
  overflow-y: scroll;
  ul {
    padding: 0;
    list-style: none;
    box-sizing: border-box;
    background: #fff;
    color: #555;
    li {
      height: 56px;
      padding: 0 24px;
      line-height: 56px;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      &:not(:first-child) {
        border-top: 1px solid #eeeeee;
      }
      &.active {
        color: #2196f3;
      }
      .icon {
        color: #01ca83;
        padding-right: 10px;
        font-size: 16px;
      }
    }
  }
}
</style>
